import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { ChangePersonalAddressEnum } from './ChangePersonalAddressSchema';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import useStore from '../../../store';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { useChangePersonalAddreess } from './useChangePersonalAddreess';

interface IProps {
  businessFlow: boolean;
  getValues: any;
  onClose: any;
  t: any;
  handleErrorCode: any;
  customerId: string;
}

export const useHandleSucces = ({ businessFlow, onClose, getValues, t, handleErrorCode, customerId }: IProps) => {
  const setAccountSummary = useStore((state) => state.setSummary);

  const handleSuccess = useCallback(() => {
    const personalAddressField = {
      address: {
        line1: getValues(ChangePersonalAddressEnum.street),
        line2: getValues(ChangePersonalAddressEnum.apt),
        city: getValues(ChangePersonalAddressEnum.city),
        state: getValues(ChangePersonalAddressEnum.state),
        postalCode: getValues(ChangePersonalAddressEnum.zip),
      },
    };
    const businessAddressField = {
      businessAddress: {
        line1: getValues(ChangePersonalAddressEnum.street),
        line2: getValues(ChangePersonalAddressEnum.apt),
        city: getValues(ChangePersonalAddressEnum.city),
        state: getValues(ChangePersonalAddressEnum.state),
        postalCode: getValues(ChangePersonalAddressEnum.zip),
      },
    };
    const updatedField = businessFlow ? businessAddressField : personalAddressField;
    setAccountSummary({
      ...useStore.getState().summary,
      customer: {
        ...useStore.getState().summary.customer,
        ...updatedField,
      },
    });
    onClose();
    toast(
      <LiliNotification
        type={LiliNotificationType.SUCCESS}
        title={t('CHANGE_ADDRESS.SUCCESS.TITLE')}
        text={t('CHANGE_ADDRESS.SUCCESS.DESCRIPTION')}
        id='change-address-success-notification'
      />,
      {
        ...LiliToastDefaultConfig,
        autoClose: false,
        position: toast.POSITION.BOTTOM_CENTER,
        closeOnClick: false,
        closeButton: true,
      },
    );
  }, [businessFlow, getValues, onClose, setAccountSummary, t]);

  const { isLoading, mutate: mutateChangeAddress } = useChangePersonalAddreess(
    handleSuccess,
    handleErrorCode,
    businessFlow,
  );

  const handleConfirm = useCallback(() => {
    mutateChangeAddress({
      street: getValues(ChangePersonalAddressEnum.street),
      apt: getValues(ChangePersonalAddressEnum.apt),
      city: getValues(ChangePersonalAddressEnum.city),
      state: getValues(ChangePersonalAddressEnum.state),
      zip: getValues(ChangePersonalAddressEnum.zip),
      customerId,
      businessFlow,
    });
  }, [getValues, businessFlow]);

  return { isLoading, handleConfirm };
};
